/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useEffect } from 'react';
import Intro from './Intro';
import Ministries from './Ministries';
import Sermons from './Sermons';
import DonateBanner from './DonateBanner';
import AnnouncementBanner from './Announcement/AnnouncementBanner';
import WhatsHappening from './Events/WhatsHappening';
import { Box, Button } from '@mui/material';
// import Calendar from './Events/Calendar';
import { useAuth } from '../context/AuthContext';
import Seo from './Seo';

const Step = ({ value, width = '30%' }: { value: string; width?: string }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#800080',
        color: '#ffc000',
        padding: 0,
        fontSize: { xs: '1rem', md: '1.5rem' },
        width,
        mt: 2,
        mb: 2,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontWeight: 'bold',
        paddingTop: 2,
        paddingBottom: 2,
      }}
    >
      <div>{value.toUpperCase()}</div>
    </Box>
  );
};

const Text = ({ value }: { value: string }) => {
  return (
    <Box
      sx={{
        backgroundColor: '#fff3cc',
        color: '#ff0000',
        flex: 1,
        padding: 2,
        fontSize: { xs: '1rem', md: '1.5rem' },
        mt: 2,
        mb: 2,
        fontWeight: 'bold',
        whiteSpace: 'break-spaces',
      }}
    >
      {value}
    </Box>
  );
};

const info = [
  {
    step: 'step one',
    text: `*New Budget process begins with Pastoral Vision and Goals and \n*Ministry goals and budget requests`,
  },
  {
    step: 'step two',
    text: `Development of the proposed budget by the budget committee`,
  },
  {
    step: 'step three',
    text: `Proposed Budget presented to Pastor, Trustees, Deacons, & Finance Committee For input and approval`,
  },
  {
    step: 'step four',
    text: `Proposed Budget presented at NMZ Business Meeting for final approval`,
  },
  {
    step: 'step five',
    text: `2024 BUDGET implemented on January 1, 2024`,
  },
];
const BudgetSteps = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        flexDirection: 'column',
        alignItems: 'center',
        m: 2,
      }}
    >
      <a
        href="/forms/budget-request-form-2026"
        style={{ textDecoration: 'none' }}
        target="_blank"
        rel="noreferrer"
      >
        <img
          src={require('./../images/budget_2026.png')}
          style={{ width: '100%' }}
          alt="2026 Budget Request Form"
        />
      </a>
      <Button variant="outlined" href="/forms/budget-request-form-2026">
        LEARN MORE AND OBTAIN FORMS
      </Button>
    </Box>
  );
};
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const Home = () => {
  const { isChildcareAdmin, isKioskMode } = useAuth();

  useEffect(() => {
    if (isChildcareAdmin) {
      window.location.replace('/checkin/admin');
    }
    if (isKioskMode) {
      window.location.replace('/checkin/kiosk');
    }
  }, [isChildcareAdmin, isKioskMode]);

  return (
    <div>
      <Seo
        title="Home"
        description="New Mt. Zion Missionary Baptist Church in Lakeland, FL — join us for worship, ministries, events, and community."
        path="/"
      />
      <AnnouncementBanner />
      {/* <img src={require('./../images/be_safe.png')} style={{ width: '100%' }} alt="Be Safe guidelines" /> */}

      <Intro />
      <Sermons />
      {/* <Calendar /> */}
      <WhatsHappening />
      {/* <BudgetSteps /> */}
      <Ministries />

      <DonateBanner />
    </div>
  );
};

export default Home;
